import React from 'react';

const polarToCartesian = (cx, cy, r, angleDeg) => {
    const angleRad = ((angleDeg - 90) * Math.PI) / 180.0;
    return {
        x: cx + r * Math.cos(angleRad),
        y: cy + r * Math.sin(angleRad),
    };
};

const describeArc = (cx, cy, r, startAngle, endAngle) => {
    const start = polarToCartesian(cx, cy, r, endAngle);
    const end = polarToCartesian(cx, cy, r, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    return [
        'M', start.x, start.y,
        'A', r, r, 0, largeArcFlag, 0, end.x, end.y
    ].join(' ');
};

const CustomGauge = ({
                 value,
                 min = 0,
                 max = 100,
                 startAngle = -110,
                 endAngle = 110,
                 size = 200,
                 strokeWidth = 20,
                 color = '#1976d2',
                 backgroundColor = '#e0e0e0',
                 children,
             }) => {
    const radius = (size - strokeWidth) / 2;
    const cx = size / 2;
    const cy = size / 2;
    const pct = Math.min(Math.max((value - min) / (max - min), 0), 1);
    const currentAngle = startAngle + pct * (endAngle - startAngle);

    const bgPath = describeArc(cx, cy, radius, startAngle, endAngle);
    const valuePath = describeArc(cx, cy, radius, startAngle, currentAngle);

    return (
        <div style={{ position: 'relative', width: size, height: size - 30, margin: '0 auto' }}>
            <svg width={size} height={size - 30}>
                <path
                    d={bgPath}
                    stroke={backgroundColor}
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeLinecap="round"
                />
                <path
                    d={valuePath}
                    stroke={color}
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeLinecap="round"
                />
            </svg>
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                }}
            >
                {children}
            </div>
        </div>
    )
}

export default CustomGauge;
